<!--
 * @Description: 
 * @Autor: yd
 * @Date: 2020-11-03 13:43:24
 * @最后编辑: Betway
 * @最后修改时间: 2022-02-07 10:30:33
-->
<template>
  <v-card class="bigbox">
    <v-card-text>
      <v-row>
        <v-col cols="12" sm="6">
          <mrc_ess_prompt
            :label="$t('label_staff_property_group_name')"
            @getData="change"
            v-model="property_group_uuid"
            :obj="sys_property_group"
          >
          </mrc_ess_prompt>
        </v-col>
      </v-row>
      <propertygroup readonly :treeList="allList"> </propertygroup>
    </v-card-text>
    <mrc_ess_submitBtn
      @success="success"
      :loading="loading"
      @cancel="cancel"
      :cancelText="
        !$store.state.uuid ? $t('label_The_previous_step') : $t('label_cancel')
      "
    >
    </mrc_ess_submitBtn>
  </v-card>
</template>

<script>
import {
  getStaffPropertyGroupDetail,
  getPropertyGroupDetail,
  deleteStaffPropertyGroup,
  updateStaffPropertyGroup,
  addStaffPropertyGroup,
  getAddList,
} from "@/service/api/staffPropertyGroup.js";
import propertygroup from "./staffGroup.vue";
export default {
  components: {
    propertygroup,
  },
  props: {
    readonly: {
      type: Boolean,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    itemText: {
      type: String,
      default: "staff_property_master_name",
    },
  },
  data() {
    return {
      property_group_uuid: "",
      allList: [], //所有属性
    };
  },
  created() {},
  async mounted() {
    // await this.getdetail()
  },
  methods: {
    async change(val) {
      await this.getdetail();
    },
    async getdetail() {
      //获取整个列表
      if (!this.property_group_uuid) return;
      const res = await getStaffPropertyGroupDetail({
        //获取树
        uuid: this.property_group_uuid,
      });
      this.$store.commit("set_uuid", res.data.uuid);
      this.allList = res.data.mrbase_sys_staff_property_group_default_value;
    },
    success() {
      //获取属性详情 提交
      // if (!this.property_group_uuid) return this.$Message({ text: '员工属性必填', color: 'rgba(0,0,0,0.78)' })
      this.$emit("submit", this.property_group_uuid);
    },
    cancel() {
      //上一步
      this.$emit("changee2", 1);
    },
  },
  computed: {
    sys_property_group() {
      return {
        prompt_name: "sys_property_group",
        org_level_uuid: this.$store.state.currentCompany,
      };
    },
  },
  watch: {},
};
</script>

<style scoped>
.bigbox {
  text-align: left;
  border-bottom-right-radius: 4px;
  border-bottom-left-radius: 4px;
}
.rowbox {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 35vw;
}
/deep/ .v-treeview-node__root {
  border-bottom: 1px solid #e8e8e8;
}
</style>
